import Rete, { Socket} from "rete";
import VueStockDataListControl from "./StockDataListControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class StockDataListControl extends Rete.Control {
  constructor(emitter, key, stocks) {
    super(key);
    this.render = "vue";
    this.component = VueStockDataListControl;
    this.props = { emitter, ikey: key, stocks };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const StockDataSocket = new Socket("StockData");
StockDataSocket.combineWith(AnyTypeSocket);
export { StockDataSocket };

